import { Component, EventEmitter, Output, Input, Renderer, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'bari-modal',
  templateUrl: './bari-modal.component.html',
  styleUrls: ['./bari-modal.component.scss']
})
export class BariModalComponent implements OnInit {
  @Output() modalClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() closeicon: boolean;
  @Input() header;
  @Input() busy: boolean;
  @Input() center: boolean;
  @Input() small: boolean;

  public addTop = true;

  constructor(private router: Router, private _render: Renderer, private _el: ElementRef) { }

  ngOnInit() {
    if (this.header === 'dark') {
      this._render.setElementClass(this._el.nativeElement, 'header-dark', true);
    }
    if (this.header === 'no') {
      this._render.setElementClass(this._el.nativeElement, 'header-no', true);
    }
    if (this.center) {
      this._render.setElementClass(this._el.nativeElement, 'center', true);
    }

    if (this.small) {
      this._render.setElementClass(this._el.nativeElement, 'size-small', true);
    }
  }

  closeModal($event) {
    this.router.navigate([{ outlets: { modal: null } }]);
    this.modalClose.next($event);
  }
}
